export default {
  downloadapp: {
    get_app: "احصل على التطبيق",

    title1: "طريقة سهلة لطلب",
    title2: "طعامك",
    faster: "بسرعة أكبر",

    desc:
      "قم بإدارة مشترياتك الغذائية بسهولة مع الأسعار الفورية والموردين الموثوقين والتوصيل الموثوق — كل ذلك من تطبيق واحد.",

    text:
      "من المستخدمين الجدد إلى أصحاب الأعمال المتنامية، يتيح لك تطبيق MAHAL إدارة الطلبات والتواصل مع شركاء موثوقين وتتبع المعاملات في الوقت الفعلي — كل ذلك من هاتفك الذكي.",

    download_on: "حمّل من",
    app_store: "متجر التطبيقات",

    get_it_on: "احصل عليه من",
    play_store: "متجر بلاي",
  },
};